import { render, staticRenderFns } from "./chineseJournals.vue?vue&type=template&id=4996969e&scoped=true"
import script from "./chineseJournals.vue?vue&type=script&lang=js"
export * from "./chineseJournals.vue?vue&type=script&lang=js"
import style0 from "./chineseJournals.vue?vue&type=style&index=0&id=4996969e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996969e",
  null
  
)

export default component.exports